import {loadable} from 'router/routes';
import {Page} from 'router/page';
import {fetchCleanedData} from 'router/router-actions';

const Checkout = loadable(() => import('checkout/Checkout'));

Checkout.getInitialState = async ({state: initialState, route}) => {
    // TODO: `fetchCleanedData` is a relic of the previous data-fetching system and does more than Checkout needs

    const state = await fetchCleanedData({
        state: initialState,
        route,
    });

    state.searchRequest.pageType = Page.CHECKOUT;

    return state;
};

export default Checkout;
